import { useNavigate } from 'react-router-dom';
import { Dropdown, MenuProps } from 'antd';
import { formatNumber } from '../../../utils/helper';
import CustomTable from '../../CustomTable';
import WarehouseTableMobileCard from './WarehouseTableMobileCard';
import { ExportTwoIcon, PlusIcon, MoreIcon } from '../../icons';
import FilterWarehouse from './FilterWarehouse';

const WarehouseTable = () => {
    const navigate = useNavigate();

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div className='flex items-center menu-otps'>
                    <span className='ml-2'>Edit Details</span>
                </div>
            )
        },
        {
            key: '2',
            label: (
                <div className='flex items-center menu-otps'>
                    <span className='ml-2'>View about Warehosue</span>
                </div>
            )
        },
        {
            key: '3',
            label: (
                <div className='flex items-center menu-otps'>
                    <span className='ml-2'>Extract to CSV</span>
                </div>
            )
        }
    ];

    return (
        <>
            <div className='lg:hidden pb-[40px] pt-4 mt-[24px] bg-white max-w-[100vw]'>
                <div className='flex items-center justify-between border-b border-appcolorfaintnine py-4 mx-4'>
                    <h5>Warehouse </h5>
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: '1',
                                    label: (
                                        <button
                                            className='flex items-center h-[52px] w-[150px] gap-[16px] text-steelBlue text-base'
                                            onClick={() => {}}
                                        >
                                            <FilterWarehouse
                                            // {...{
                                            //     setTransactionFilterOptions,
                                            //     beneficiaries
                                            // }}
                                            />
                                        </button>
                                    )
                                },
                                {
                                    key: '2',
                                    label: (
                                        <button
                                            className='flex items-center h-[52px] w-[150px] gap-[16px] text-steelBlue text-base'
                                            onClick={() => {}}
                                        >
                                            <ExportTwoIcon />
                                            <span>Extract</span>
                                        </button>
                                    )
                                },
                                {
                                    key: '3',
                                    label: (
                                        <button
                                            className='flex items-center h-[52px] w-[150px] gap-[16px] text-steelBlue text-base'
                                            onClick={() =>
                                                navigate('/stock/add-warehouse')
                                            }
                                        >
                                            <PlusIcon />
                                            <span>Add warehouse</span>
                                        </button>
                                    )
                                }
                            ]
                        }}
                        trigger={['click']}
                    >
                        <div
                            style={{
                                cursor: 'pointer'
                            }}
                        >
                            <MoreIcon />
                        </div>
                    </Dropdown>
                </div>
            </div>

            <CustomTable
                loadingData={false}
                data={[]}
                columns={[
                    {
                        title: 'Warehouse name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text) => (
                            <span className=''>{text ?? '-'}</span>
                        )
                    },
                    {
                        title: 'Location',
                        dataIndex: 'location',
                        key: 'location',
                        render: (text) => (
                            <span className=''>{text ?? '-'}</span>
                        )
                    },
                    {
                        title: 'Size',
                        dataIndex: 'size',
                        key: 'size',
                        render: (text) => (
                            <span className=''>{formatNumber(text ?? 0)}</span>
                        )
                    },
                    {
                        title: 'Status',
                        dataIndex: 'status',
                        key: 'status',
                        render: (text) => (
                            <span className=''>{text ?? '-'}</span>
                        )
                    },
                    {
                        title: '',
                        render: (_, data) => (
                            <div
                                className='cursor-pointer'
                                // onClick={() => {
                                //   props.setCurrentData(data)
                                // }}
                            >
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                    placement='bottomRight'
                                >
                                    <img
                                        src='/img/vectors/more.svg'
                                        alt='more'
                                    />
                                </Dropdown>
                            </div>
                        )
                    }
                ]}
                mobileComponent={<WarehouseTableMobileCard />}
            />
        </>
    );
};

export default WarehouseTable;
